import { Flame, Target } from "lucide-react";

import { getCombinedMacroStatus, getMacroProgress, getMacroStatus } from "@/lib/macros";


const toneClasses = {
  emerald: "bg-emerald-100 text-emerald-800",
  amber: "bg-amber-100 text-amber-800",
  rose: "bg-rose-100 text-rose-800",
  stone: "bg-stone-100 text-stone-700",
};


const progressClasses = {
  emerald: "bg-emerald-500",
  amber: "bg-amber-500",
  rose: "bg-rose-500",
  stone: "bg-stone-400",
};


const MacroRow = ({ icon: Icon, label, planned, target, suffix, testId }) => {
  const status = getMacroStatus(planned, target);
  const progress = getMacroProgress(planned, target);

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 text-stone-700">
          <Icon className="h-4 w-4" />
          <span>{label}</span>
        </div>
        <div className="text-right text-stone-600">
          <span className="font-semibold text-stone-900">{planned}</span>
          <span> / {target} {suffix}</span>
        </div>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-stone-100" data-testid={`${testId}-progress-track`}>
        <div className={`h-full rounded-full transition-[width] duration-300 ${progressClasses[status.tone]}`} style={{ width: `${progress}%` }} data-testid={`${testId}-progress-bar`} />
      </div>
      <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${toneClasses[status.tone]}`} data-testid={`${testId}-status-pill`}>
        {status.label}
      </span>
    </div>
  );
};


export const PlannerMacroStrip = ({ day }) => {
  const combined = getCombinedMacroStatus({
    kcalPlanned: day.kcal_total,
    kcalTarget: day.kcal_target,
    carbsPlanned: day.carb_total,
    carbsTarget: day.carb_target,
  });

  return (
    <section className="rounded-[26px] border border-stone-200 bg-white/92 p-4" data-testid="planner-macro-strip">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-500" data-testid="planner-macro-strip-kicker">
            Macro fit
          </p>
          <h3 className="mt-2 text-base font-semibold text-stone-900" data-testid="planner-macro-strip-title">
            Vandaag snel in beeld: kcal + carbs versus je target.
          </h3>
        </div>
        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${toneClasses[combined.tone]}`} data-testid="planner-macro-strip-fit-pill">
          <Target className="mr-1.5 h-3.5 w-3.5" />
          {combined.label}
        </span>
      </div>

      <div className="mt-4 space-y-4">
        <MacroRow icon={Flame} label="Calorieën" planned={day.kcal_total} target={day.kcal_target} suffix="kcal" testId="planner-macro-kcal-row" />
        <MacroRow icon={Target} label="Carbs" planned={day.carb_total} target={day.carb_target} suffix="g" testId="planner-macro-carb-row" />
      </div>
    </section>
  );
};